import actions from './actions';
import mutations from './mutations';
import state from './initialState';
import getters from './getters';

const vettings = {
  namespaced: true,

  state,

  mutations,

  actions,

  getters,
};

export default vettings;
